export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Din ordre er set',
    order_confirmed: '#{{number}} Bekræftet tidspunkt {{time}}',
    order_preparation_up_time_changed: '#{{number}} Tidspunkt for {{type}} ændret til {{time}}',
    serving_time_changed: '#{{number}} Din ordre serveres kl. {{time}}',
    order_preparing: 'Din ordre #{{number}} bliver tilberedt',
    order_rejected: '#{{number}} ordre afvist',
  },
  order_type: {
    pickup: 'Afhentning',
    delivery: 'Levering',
  },
};
